function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useSignal } from "@preact/signals-react";
export var ExcelFileType = /*#__PURE__*/function (ExcelFileType) {
  ExcelFileType[ExcelFileType["XLSX"] = 0] = "XLSX";
  ExcelFileType[ExcelFileType["CSV"] = 1] = "CSV";
  return ExcelFileType;
}({});
export var ExcelTableViewState = /*#__PURE__*/_createClass(function ExcelTableViewState() {
  _classCallCheck(this, ExcelTableViewState);
  _defineProperty(this, "loadFinish", useSignal(false));
  _defineProperty(this, "totalRows", useSignal([]));
  _defineProperty(this, "allKeys", useSignal([]));
  _defineProperty(this, "currentPageRows", useSignal([]));
  _defineProperty(this, "pageIndex", useSignal(1));
  _defineProperty(this, "pageCount", useSignal(1));
  _defineProperty(this, "perPageRowsCount", 10);
  _defineProperty(this, "errorText", useSignal(null));
});
export var ExcelTableViewBloc = /*#__PURE__*/function () {
  function ExcelTableViewBloc(state) {
    _classCallCheck(this, ExcelTableViewBloc);
    this.state = state;
  }
  _createClass(ExcelTableViewBloc, [{
    key: "loadData",
    value: function loadData(fileUrl, fileType) {
      var _this = this;
      // worker内部，用blob实现
      var workerFunctionStr = "\n      onmessage = e => {\n        importScripts(\"https://cdn.sheetjs.com/xlsx-0.20.0/package/dist/xlsx.full.min.js\");\n\n        let data = e.data\n        fetch(data.fileUrl)\n          .then(response => response.arrayBuffer())\n          .then(arrayBuffer => {\n            let wb;\n            if (e.data.fileType === 1) {\n              let encoder = new TextDecoder(\"utf-8\");\n              const result = encoder.decode(arrayBuffer);\n              wb = XLSX.read(result, { type: \"string\" }); // parse the array buffer\n            } else {\n              wb = XLSX.read(arrayBuffer);\n            }\n            if (wb === undefined) {\n              const error = \"Please upload a valid excel file.\";\n              postMessage({ error });\n              return;\n            }\n\n            const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet\n            const data = XLSX.utils.sheet_to_json(ws); // generate objects\n            let keys = Object.entries(data[0]).map(([key, value]) => {\n              return key;\n            });\n\n            postMessage({\n                data,\n                keys,\n              });\n          });\n      };\n    ";
      var blob = new Blob([workerFunctionStr]);
      var url = URL.createObjectURL(blob);
      var worker = new Worker(url);

      // 主线程监听消息
      worker.onmessage = function (e) {
        var data = e.data;
        if (data.error) {
          _this.state.errorText.value = data.error;
          return;
        }
        var totalRows = data.data;
        var totalRowsCount = totalRows.length;
        var perPageRowsCount = _this.state.perPageRowsCount;
        _this.state.totalRows.value = totalRows;
        var currentPageRows = totalRows;
        if (totalRowsCount > perPageRowsCount) {
          currentPageRows = totalRows.slice(0, perPageRowsCount);
        }
        _this.state.currentPageRows.value = currentPageRows;
        _this.state.pageIndex.value = 1;
        _this.state.pageCount.value = Math.ceil(totalRowsCount / perPageRowsCount);
        _this.state.loadFinish.value = true;
        _this.state.allKeys.value = data.keys;
      };

      // 开始子线程解析文件
      worker.postMessage({
        fileUrl: fileUrl,
        fileType: fileType
      });
    }
  }, {
    key: "updateCurrentPage",
    value: function updateCurrentPage() {
      var index = this.state.pageIndex.value;
      if (index < 0 || index > this.state.pageCount.value) {
        return;
      }
      var start = (index - 1) * this.state.perPageRowsCount;
      var end = index * this.state.perPageRowsCount;
      this.state.currentPageRows.value = this.state.totalRows.value.slice(start, end);
    }
  }, {
    key: "onPreviousPage",
    value: function onPreviousPage() {
      if (this.state.pageIndex.value < 2) {
        return;
      }
      this.state.pageIndex.value -= 1;
      this.updateCurrentPage();
    }
  }, {
    key: "onNextPage",
    value: function onNextPage() {
      if (this.state.pageIndex.value >= this.state.pageCount.value) {
        return;
      }
      this.state.pageIndex.value += 1;
      this.updateCurrentPage();
    }
  }]);
  return ExcelTableViewBloc;
}();